import { Controller } from "@hotwired/stimulus"

// Shows the time since a start timestamp (seconds since epoch), updated every second: "1:05:09".
export default class extends Controller {
  static values = { startedAt: Number }

  connect() {
    this.render()
    this.interval = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  render() {
    const seconds = Math.max(0, Math.floor(Date.now() / 1000 - this.startedAtValue))
    const h = Math.floor(seconds / 3600)
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0")
    const s = String(seconds % 60).padStart(2, "0")
    this.element.textContent = `${h}:${m}:${s}`
  }
}
